// Track a page view for hubspot on turbo visit and not on load because
// hubspot will track the page initially loading.
// We don't need to set the url since it should get it from history.
document.addEventListener('turbo:visit', function () {
  const _hsq = window._hsq = window._hsq || []
  _hsq.push(['trackPageView'])
})
